import React from 'react'
import axios from 'axios'
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap'

export default class PayslipPreview extends React.Component {
  state = { open: false, loading: false, url: '', error: '' }
  requestId = 0

  componentWillUnmount() {
    this.requestId++
    this.releaseUrl()
  }

  releaseUrl = () => {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }

  close = () => {
    this.requestId++
    this.releaseUrl()
    this.setState({ open: false, loading: false, url: '', error: '' })
  }

  preview = async () => {
    const { salaryId, month, year } = this.props
    const requestId = ++this.requestId
    this.releaseUrl()
    if (Number(year) < 2023 || (Number(year) === 2023 && Number(month) < 4)) {
      this.setState({ open: true, loading: false, url: '', error: 'Kjo pagë për momentin nuk mund të shikohet!' })
      return
    }
    this.setState({ open: true, loading: true, url: '', error: '' })
    try {
      const response = await axios.post(`salaries/${salaryId}`, null, { responseType: 'blob' })
      if (requestId !== this.requestId) return
      if (!(response.headers['content-type'] || '').toLowerCase().startsWith('application/pdf')) {
        throw new Error('Invalid PDF response')
      }
      this.objectUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      this.setState({ loading: false, url: this.objectUrl })
    } catch (error) {
      if (requestId === this.requestId) {
        this.setState({ loading: false, error: 'Gabim gjatë hapjes së dokumentit. Ju lutem provoni përsëri.' })
      }
    }
  }

  render() {
    const { open, loading, url, error } = this.state
    return (
      <React.Fragment>
        <Button outline className='mb-1' color='info' type='button' onClick={this.preview}>Shiko</Button>
        <Modal
          isOpen={open}
          toggle={this.close}
          style={{ width: '50vw', minWidth: 'min(600px, calc(100vw - 2rem))', maxWidth: 'calc(100vw - 2rem)' }}
        >
          <ModalHeader toggle={this.close}>Paga — {this.props.month}/{this.props.year}</ModalHeader>
          <ModalBody>
            {loading && <p role='status'>Duke gjeneruar dokumentin...</p>}
            {error && <p role='alert' className='text-danger'>{error}</p>}
            {url && <iframe title='Fletëpagesa' src={url} style={{ width: '100%', height: '75vh', border: 0 }} />}
          </ModalBody>
        </Modal>
      </React.Fragment>
    )
  }
}
